module.exports = __webpack_public_path__ + "img/angry.e7f53d17.png";